(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AllInclusivePropertyBooking',
	};

	var $modal = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var $saved_cards        = $form.find('.credit-cards'),
		    $saved_cards_parent = $saved_cards.parents('.form-group');

		Adzuki.Erez.AllInclusiveProperties.ImageGallery();

		// if selecting an existing client, get their cc info to pre-fill fields
		// we only want the one for hardcoded user 1337, the booking holder
		$("#allinclusivepropertybooking-neworexistingclient-1337-existingclient-existing_client_name").on('ta.set-hidden', function getClientCCs(e, client_id)
		{
			$saved_cards.get(0).options.length = 1;

			fetchClientCreditCards(client_id);

			Adzuki.Ajax.get('/Clients/getPhoneNumbers/'+client_id)
			.then(function fillClientPhone(phone_data) {
				$('#allinclusivepropertybooking-billing-payment-phone').val(phone_data.primary);
			});

			Adzuki.Ajax.get('/Clients/getClientEmail/'+client_id)
			.then(function fillClientEmail(email_data) {
				$('#allinclusivepropertybooking-billing-payment-email').val(email_data[client_id]);
			});
		})
		.on('ta.reset', function resetCCField()
		{
			$saved_cards_parent.addClass('hidden');
			$saved_cards.get(0).options.length = 1;
			$("#allinclusivepropertybooking-billing-payment-expiration").data('DateTimePicker').clear();

			$([
				'#allinclusivepropertybooking-billing-payment-phone',
				'#allinclusivepropertybooking-billing-payment-email',
				'#allinclusivepropertybooking-billing-payment-name_on_card',
				'#allinclusivepropertybooking-billing-payment-credit_card_type',
				'#allinclusivepropertybooking-billing-payment-number',
				'#allinclusivepropertybooking-billing-payment-cvv',
				'#allinclusivepropertybooking-billing-payment-address1',
				'#allinclusivepropertybooking-billing-payment-address2',
				'#allinclusivepropertybooking-billing-payment-city',
				'#allinclusivepropertybooking-billing-payment-state',
				'#allinclusivepropertybooking-billing-payment-zip',
			].join(',')).val('');
		});

		$saved_cards.on('change', function fetchCCData() {
			Adzuki.Ajax.get('/ClientCreditCards/get/'+$(this).val()+'/1/1')
			.then(function fillBillingInfo(cc_info)
			{
				var $cc_number    = $('#allinclusivepropertybooking-billing-payment-number'),
				    num_token     = (cc_info.number_token ? cc_info.number_token : null),
				    $ccv_number   = $('#allinclusivepropertybooking-billing-payment-cvv'),
				    ccv_token     = (cc_info.ccv_token ? cc_info.ccv_token : ''),
				    secure_tokens = [];

				if (num_token === null) {
					$cc_number.removeAttr('data-token');
					$ccv_number.removeAttr('data-ccv_token');

					$cc_number.val('').focus();
					$ccv_number.val('');
				} else {
					$cc_number.attr('data-token', num_token);
					$ccv_number.attr('data-ccv_token', ccv_token);

					secure_tokens[0] = num_token;

					if (ccv_token !== '') {
						secure_tokens[1] = ccv_token;
					}

					Adzuki.SecureStorage.detokenize({
						secure_storage_tokens: secure_tokens,
						success              : function success(plain_texts) {
							$cc_number.val(plain_texts[0]);

							if (plain_texts.length === 2) {
								$ccv_number.val(plain_texts[1]);
							}
						}
					});
				}

				$("#allinclusivepropertybooking-billing-payment-name_on_card").val(cc_info.name);
				$("#allinclusivepropertybooking-billing-payment-credit_card_type").val(cc_info.credit_card_sabre_code);
				$("#allinclusivepropertybooking-billing-payment-address1").val(cc_info.address1);
				$("#allinclusivepropertybooking-billing-payment-address2").val(cc_info.address2);
				$("#allinclusivepropertybooking-billing-payment-city").val(cc_info.city);
				$("#allinclusivepropertybooking-billing-payment-state").val(cc_info.state_iso);
				$("#allinclusivepropertybooking-billing-payment-zip").val(cc_info.zip);
				$("#allinclusivepropertybooking-billing-payment-expiration").data('DateTimePicker').date(moment(cc_info.expiration));
			});
		});

		// reset existing client when 'new client' is selected,
		// only for the booking holder/paying client though
		// $('.new-or-existing').on('change', function resetClientInfo() {
		// 	var $self = $(this);
		// 	if ($self.data('index') === 1337 && $self.val() === 'new') {
		// 		$self.parents('.new-or-existing-client').find('.reset-typeahead a').click();
		// 	}
		// });

		$('.enlarge-image').click(function showImageInModal(e) {
			e.preventDefault();

			$modal.find('.modal-title').text('Resort Image');
			$('.modal-dialog').addClass('modal-lg');
			$modal.find('.modal-body').html('<img src="' + $(this).data('url') +'" class="img-responsive center-block">');
			$modal.modal('show');
		});

		function fetchClientCreditCards(client_id) {
			Adzuki.Ajax.get('/ClientCreditCards/getCardsByClientId/'+client_id+'/1/1')
			.then(function fillClientCCs(cc_data)
			{
				$saved_cards_parent.removeClass('hidden');
				$.each(cc_data, function populateCCSelect(sKey, sValue) {
					$saved_cards.append($('<option>').text(sValue).attr('value', sKey));
				});
			});
		}
	};
}(jQuery, window.Adzuki || {}));